// imports
import React from 'react';
import GameStatePopup from '../molecules/gameState';

// interfaces / types / consts
interface Props { content: JSX.Element }

// exports
export default function Header(props: Props): JSX.Element {
  const { content } = props;
  // hooks configuration
  return (
    <>
      <GameStatePopup />
      <div className="header">
        <div className="header-bar">
          <div className="header-container">{content}</div>
        </div>
      </div>
    </>
  );
}
